import { atomWithStorage } from 'jotai/utils';

const oneTrustConsentAtom = atomWithStorage('oneTrustConsent', true);

export default oneTrustConsentAtom;
